<div class="rx-intuitive-summary-footer" id="rx-summary-send-footer">
	<button
		*ngIf="isContinueToLabBrokerButtonVisible && !labBrokerSendStepBypassed"
		tlkButton
		size="l"
		id="rx-summary-continue-to-integrator-button"
		data-testid="continue-to-integrator-button"
		(click)="continueToLabBrokerClicked.emit()"
	>{{ 'SummaryFooter.ContinueToButtonText' | translate: { name: continueToLabBrokerName } }}</button>
	<button
		*ngIf="!isContinueToLabBrokerButtonVisible || labBrokerSendStepBypassed "
		tlkButton
		size="l"
		id="rx-summary-send-button"
		(click)="sendClicked.emit()"
	>{{ 'IntuitivePatient.Confirm' | translate }}</button>
</div>
